<template>
  <div class="cookAllowance">
    <div class="p16 align-items">
      <p style="font-weight: bold;">库存查询</p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <el-tabs v-model="activeName" type="card" class="pltr16" @tab-click="tabClick">
            <el-tab-pane label="产品" name="product"></el-tab-pane>
            <el-tab-pane label="耗材" name="consumable"></el-tab-pane>
          </el-tabs>
          <el-select v-model="categoryId" placeholder="全部" filterable class="plrb16" @change="onChange">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="productName" width="auto" label="名称"></el-table-column>
              <el-table-column prop="oxCname" width="auto" label="数量">
                <template slot-scope="scope">
                  {{scope.row.inventoryNum}}{{scope.row.unit}}
                </template>
              </el-table-column>
              <el-table-column prop="warningStatus" width="auto" label="预警情况"></el-table-column>
              <el-table-column prop="oxCname" width="80" label="报表">
                <template slot-scope="scope">
                  <el-link type="primary" @click="details(scope.row)">查看</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      height: this.$store.getters.MainHeight,
      options: [],
      categoryId: '',
      activeName: 'product',
      oldActiveName: 'product'
    };
  },
  components: {},
  created() {
    this.totalCounts();
    this.companyStaffList();
  },
  mounted() {},
  methods: {
    handleClose () {
      this.dialogVisible = false;
    },
    companyStaffList() {
      this.$api.get(this.$url.inventoryProduct.listForCategory, {productType: this.activeName}).then(res => {
        if (res) {
          this.options = res;
        }
      })
    },
    totalCounts () {
      this.$api.get(this.$url.inventoryProduct.getShopForProduct, {categoryId: this.categoryId, productType: this.activeName}).then(res => {
        if (res) {
          this.list = res.inventoryProductBOList;
        }
      })
    },
    details (row) {
      this.$router.push({
        path: "/dataList/inventoryInquire/dayReport",
        query: {
          id: row.productId
        }
      });
      let obj = {
        productName: row.productName,
        productTypeCn: row.productTypeCn,
        storageUnit: row.unit,
      }
      sessionStorage.setItem('inquireObj', JSON.stringify(obj));
    },
    tabClick (tab) {
      if (this.oldActiveName != tab.name) {
        this.oldActiveName = tab.name;
        this.categoryId = '';
        this.totalCounts();
        this.companyStaffList();
      }
    },
    onChange () {
      this.totalCounts();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.cookAllowance {
  height: 100%;
  .mains-content {
    height: calc(100vh - 127px);
    background: #fff;
    border-radius: 10px;
  }
}
</style>